import { ActionReducerMap } from '@ngrx/store';
import { authenticationReducer } from '@warema/shared/authentication/api';
import { searchReducer, activityReducer, productCategoriesReducer } from '@warema/shared/company-search/api';
import { AppState } from './AppState';

export const reducers: ActionReducerMap<AppState> = {
    search: searchReducer,
    productCategories: productCategoriesReducer,
    activities: activityReducer,
    authentication: authenticationReducer,
};
